import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import requestApi from '../../utils/request2'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import { useAdminInfo } from '../../context/AdminContextDetail'
import CMSEditor from '../CMSEditor/CMSEditor'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ckeditor, { CKEditor } from '@ckeditor/ckeditor5-react'
import Swal from 'sweetalert2'
const PrivacyPolicy = () => {
    const {
        handleSubmit,
        formState: { errors }
    } = useForm({})
    const [currentCmsId, setCurrentCmsId] = useState()
    const [ckeditordata, setckeditordata] = useState(null)
    function handleCKEditor(event, editor) {
        const data = editor.getData()
        setckeditordata(data)
    }
    async function getPrivacyPolicy() {
        return requestApi(
            'get',
            `/cms/list`,
            {},
            { slug: 'privacypolicy' },
            true
        ).then((res) => {
            setCurrentCmsId(res?.data?.data?.cmsId)
            setckeditordata(res?.data?.data)
            return res?.data?.data
        })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['CMSlist'],
        queryFn: getPrivacyPolicy
    })

    const [editorState, seteditorState] = useState()
    // const [currentId,setCurrentid] = useState()
    async function addEditPolicy(payload) {
      
        return requestApi(
            'POST',
            `/cms/add-edit`,
            { ...payload, 
                cmsId: currentCmsId,
                title:"privacypolicy"
            },
            { },
            true
        )
    }
    const editMutation = useMutation(addEditPolicy, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: error?.message
            })
        }
    })

    const onEditSubmit = (data) => {
        const payload = {
            description: ckeditordata
        }
        editMutation.mutate(payload)
    }

    return (
        <CMSEditor>
            <div className="myaccount-sidebar-content policy-page privacy-policy">
                <div className="page-content admin-policy">
                    <Form onSubmit={handleSubmit(onEditSubmit)}>
                        <div className="title-text">
                            <h3>Privacy Policy</h3>
                            <ButtonWithLoader cssClass="common-btn comman-auth-btn reset-btn">
                                <Button
                                    className="common-btn save-btn"
                                    type="submit"
                                >
                                    Save
                                </Button>
                            </ButtonWithLoader>
                        </div>
                       
                        <div className="policy scrollbar">
                         <CKEditor
                                // data={
                                //     ckeditordata?.description
                                //         ? ckeditordata?.description
                                //         : ckeditordata
                                // }
                                data={ckeditordata?.description?.length >= 0 ? ckeditordata?.description : ckeditordata}
                                // data={ckeditordata?.description && ckeditordata?.description}
                                editor={ClassicEditor}
                                config={{
                                    removePlugins: [
                                        'EasyImage',
                                        'ImageUpload',
                                        'MediaEmbed'
                                    ],
                                    toolbar: [
                                        'heading',
                                        '|',
                                        'bold',
                                        'italic',
                                        'link',
                                        'bulletedList',
                                        'numberedList',
                                        // "blockQuote",
                                        // 'ckfinder',
                                        '|',
                                        // 'imageTextAlternative',
                                        // 'imageUpload',
                                        // 'imageStyle:full',
                                        // 'imageStyle:side',
                                        // '|',
                                        // 'mediaEmbed',
                                        'insertTable',
                                        // "tableColumn",
                                        // "tableRow",
                                        // "mergeTableCells",
                                        '|',
                                        'undo',
                                        'redo'
                                    ]
                                }}
                                onReady={(editor) =>
                                    // ckeditordata.description
                                    console.log(editor, 'hello')
                                }
                                onChange={handleCKEditor}
                            /> 
                            {/* <CKEditor
                                // data={
                                //     ckeditordata?.description
                                //         ? ckeditordata?.description
                                //         : ckeditordata
                                // }
                                data={
                                    ckeditordata?.description
                                        ? ckeditordata?.description
                                        : "No data found"
                                }
                                editor={ClassicEditor}
                                config={{
                                    removePlugins: [
                                        'EasyImage',
                                        'ImageUpload',
                                        'MediaEmbed'
                                    ],
                                    toolbar: [
                                        'heading',
                                        '|',
                                        'bold',
                                        'italic',
                                        'link',
                                        'bulletedList',
                                        'numberedList',
                                        // "blockQuote",
                                        // 'ckfinder',
                                        '|',
                                        // 'imageTextAlternative',
                                        // 'imageUpload',
                                        'imageStyle:full',
                                        'imageStyle:side',
                                        '|',
                                        'mediaEmbed',
                                        'insertTable',
                                        // "tableColumn",
                                        // "tableRow",
                                        // "mergeTableCells",
                                        '|',
                                        'undo',
                                        'redo'
                                    ]
                                }}
                                onReady={(editor) =>
                                    // ckeditordata.description
                                    console.log(editor, 'hello')
                                }
                                onChange={handleCKEditor}
                            /> */}
                        </div>
                    </Form>
                </div>
            </div>
        </CMSEditor>
    )
}

export default PrivacyPolicy
